module.exports = __webpack_public_path__ + "dash_20_app_assets/img/avatar-s-3.7ed1da4a.jpg";